import axios from 'axios';
import { throwError } from '../../actions/error/index';
import getAuthToken from '../../formatting/getAuthToken';
import { GET_CONVERSATIONS } from './types';

export function createConversation(users) {
    return async function(dispatch) {        
        try {
            const response = await axios.post(`/api/v1/conversations`, users, {headers: {authorization: getAuthToken()}});
            return response;
        }

        catch(error) {
            dispatch(throwError(error, 'Something went wrong. We are working on a fix now!'));
        }
    }
}

export function getConversations(query) {
    return async function(dispatch) {        
        try {
            const q = (query) ? `?${query}` : '';
            const response = await axios.get(`/api/v1/conversations${q}`, {headers: {authorization: getAuthToken()}});
            dispatch({type: GET_CONVERSATIONS, payload: response});
            return response;
        }

        catch(error) {
            dispatch(throwError(error, 'Something went wrong. We are working on a fix now!'));
        }
    }
}